import { createIcon } from '@chakra-ui/react';

export const StripeMenuIcon = createIcon({
  displayName: 'StripeMenuIcon',
  viewBox: '0 0 32 32',
  path: (
    <>
      <rect x='0' width='32' height='32' fill='#6772e5' />
      <g mask='url(#mask0_47_35900)'>
        <rect
          x='-4.14062'
          y='-6.58691'
          width='40.2824'
          height='45.1765'
          fill='url(#pattern0_s)'
        />
      </g>
      <defs>
        <pattern
          id='pattern0_s'
          patternContentUnits='objectBoundingBox'
          width='1'
          height='1'
        >
          <use
            xlinkHref='#image0_47_35900'
            transform='scale(0.0046729 0.00416667)'
          />
        </pattern>
        <image
          id='image0_47_35900'
          width='214'
          height='240'
          href='data:image/png;base64,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'
        />
      </defs>
    </>
  ),
});
